// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"74":"7d47d523","743":"460372b7"}[chunkId] + ".chunk.css";
};